

<template>
  <div>
    <CRow>
      <CCol sm="12">
        <CCard v-if='partner.role == "partner"'>
          <h4 class="m-3">招待コード：{{ partner.invitation_code}}</h4>
          <h5 class="m-3">ライセンス数：{{ partner.license_count}} <span class="ml-3"></span> ユーザー数：{{ partner.user_count}}</h5>
        </CCard>
          <CCard>
            <CCardHeader>
              <CIcon name="cil-grid"/> ユーザー管理
              <div class="card-header-actions">
                <a
                  class="card-header-action"
                  rel="noreferrer noopener"
                  target="_blank"
                >
                </a>
              </div>
            </CCardHeader>
            <CCardBody>
              <CRow>
                <CCol sm="2">
                </CCol>
                <CCol sm="4">
                </CCol>
                <CCol sm="2">
                </CCol>
                <CCol sm="2">
                  <CSelect
                    label="性別"
                    :options="genderType"
                    v-model="select_gender"
                    @update:value="search"
                    name="gender"
                  />
                </CCol>
                <CCol sm="2">
                  <CSelect
                    label="ステータス"
                    :options="statusType"
                    v-model="select_status"
                    @update:value="search"
                    name="status"
                  />
                </CCol>
              </CRow>
              <CDataTable
                :hover="true"
                :striped="true"
                :items="users"
                :loading="isLoading"
                :fields="fields"
                :tableFilter="true"
                itemsPerPage="20"
                pagination
                @update:table-filter-value="search"
              >
                <template #first_name="{item}">
                  <td>
                    <CLink :href="'/users/' + item.id" > {{ item.first_name }} {{item.sur_name}} {{ item.last_name }}</CLink>
                  </td>
                </template>
                <template #birthday="{item}">
                  <td> {{formatBirthday(item.birthday)}}</td>
                </template>
                <template #gender="{item}">
                  <td> {{formatGender(item.gender)}}</td>
                </template>
                <template #created_at="{item}">
                  <td> {{formatDate(item.created_at)}}</td>
                </template>
                <template #exam_date="{item}">
                  <td> {{ formatDate(item.exam_date)}}</td>
                </template>
                <template #workday="{item}">
                  <td> {{ formatDate(item.workday)}}</td>
                </template>
                <template #leave_date="{item}">
                  <td> {{ formatDate(item.leave_date)}}</td>
                </template>
                <template #specific_skills_visa_application_date="{item}">
                  <td> {{ formatDate(item.specific_skills_visa_application_date)}}</td>
                </template>
                <template #current_industry="{item}">
                  <td> {{ industries[item.current_industry] }}</td>
                </template>
                <template #interested_industry="{item}">
                  <td> {{ formatIndustry(item.interested_industry) }}</td>
                </template>
                <template #status="{item}">
                  <td> {{ memberDic[item.status] }}</td>
                </template>
                <template #show_details="{item, index}">
                  <td class="py-2">
                    <CButton class="mr-2" color="dark" variant="outline" square size="sm" @click="showRecordModal(item, index)">編集</CButton>
                    <CButton class="mr-2" color="danger" variant="outline" square size="sm" @click="showDeleteModal(item, index)">削除</CButton>
                  </td>
                </template>
                <template #under-table>

                  <CCol sm="12" class="text-center">
                    <paginate
                      :page-count="meta.total_pages"
                      :prev-text="'前へ'"
                      :next-text="'次へ'"
                      :click-handler="paging"
                      :container-class="'pagination'">
                    </paginate>
                  </CCol>
                </template>

              </CDataTable>

            </CCardBody>
          </CCard>
      </CCol>
    </CRow>
    <user-modal  @hide="hideRecordModal()" :record="record" :recordModal="recordModal" :industryTypes="industryTypes"></user-modal>

    <CModal
      title="削除しますか？"
      color="danger"
      :show.sync="deleteModal"
    >
      <div class="text-center">
        <p>このユーザーを削除しますか？？</p>
        <p>削除してしまうと復元することはできません</p>
      </div>
      <template #footer>
        <CButton size="sm" @click="hideDeleteModal()">キャンセル</CButton>
        <CButton size="sm" color="danger" @click="deleteItem()">削除</CButton>
      </template>
    </CModal>




  </div>
</template>

<script>
import axios from 'axios';
import moment from 'moment';
import { mapGetters } from 'vuex';
import UserModal from "../../components/UserModal";
import Paginate from 'vuejs-paginate'

export default {
  name: 'Home',
  components: {UserModal, Paginate},
  data() {
    return {
      isLoading: true,

      recordModal: false,
      deleteModal: false,
      record: {},
      users: [],
      filter_cs: [],
      filter_vs: [],
      industryTypes: [],
      page: 1,
      word: "",
      sort_column: "id",
      sort_asc: "desc",
      select_gender: '',
      select_status: '',
      meta: {},
      industries: {},
      genderType: [
         {
            value: "",
            label: "",
         },
         {
            value: "man",
            label: "男性",
         },
         {
            value: "women",
            label: "女性"
         }
      ],
      statusType: [
         {
            value: "",
            label: "",
         },
         {
            value: "associate_member",
            label: "仮登録"
         },
         {
            value: "no_deposite_member",
            label: "本登録(未入金)",
         },
         {
            value: "member",
            label: "本登録"
         }
      ],
      fields: [
        { key: 'first_name', label: "姓名"},
        { key: 'status', label: "ステータス"},
        { key: 'gender', label: "性別"},
        { key: 'nationality', label: "国籍"},
        { key: 'current_industry', label: "選択中の業種"},
        { key: 'interested_industry', label: "業種"},
        { key: 'line_id', label: "FacebookID"},
        { key: 'payment_id', label: "PayPalID"},
        { key: 'created_at', label: "作成日"},
        { key: 'exam_date', label: "試験受講日"},
        { key: 'course_industry', label: "受講業種"},
        { key: 'specific_skills_visa_application_date', label: "特定技能VISA申請日"},
        { key: 'employment_hope_company', label: "就業希望企業名"},
        { key: 'employment_status', label: "就業状況"},
        { key: 'workday', label: "入社日"},
        { key: 'leave_date', label: "退社日"},
        { key: 'line_id', label: "LINE ID"},
        { key: 'show_details', label: '',  _style: 'width:15%', sorter: false, filter: false},
      ],
      memberDic: {"associate_member": "仮登録", "no_deposite_member": "本登録(未入金)", "member": "本登録"},
    }
  },
  methods: {
    formatIndustry: function(d) {
      //var s = ""
      //d.split(",").forEach(i => {
      //  s += this.industries[i] + ","
      //})
      return d
    },
    formatDate: function(d) {
        return moment(d).format("YYYY/MM/DD")
    },
    formatBirthday: function(d) {
        return moment(d).format("YYYY/MM/DD")
    },
    formatGender: function(g) {
        return (g == "man")? "男性" : "女性"
    },
    hideRecordModal: function() {
      this.recordModal = false
    },
    deleteItem: function() {
      axios
        .delete(process.env.VUE_APP_API_ENDPOINT + "/users/" + this.record.id, {headers: {'Authorization': 'Bearer ' + this.idToken}})
        .then(() => {
          this.deleteModal = false
          this.users.splice(this.itemIndex, 1)
        }).catch(error => {
          console.log(error)
        })
    },
    paging: function(n) {
      axios
        .get(process.env.VUE_APP_API_ENDPOINT + "/users?page=" + n, {headers: {'Authorization': 'Bearer ' + this.idToken}})
        .then(response => {
            this.users = response.data.users
            this.meta = response.data.meta
        }).catch(error => {
            this.errorNotify(error.response)
        })
    },
    search: function(e, c) {
      this.word = e
      if(c != undefined){
        this.filter_update(c.target.name, e)
      }
      if(e == "-") {
        this.word = ""
      }
      axios
        .get(process.env.VUE_APP_API_ENDPOINT + "/users?filter_columns=" + this.filter_cs.join(",") + "&filter_values=" + this.filter_vs.join(",") + "&page=" + this.page + "&column=" + this.sort_column + "&direction=" + this.sort_asc, {headers: {'Authorization': 'Bearer ' + this.idToken}})
        .then(response => {
          this.users = response.data.users
          this.meta = response.data.meta
        }).catch(error => {
            this.errorNotify(error.response)
        })
    },
    filter_update: function(k, v) {
      if(this.filter_cs.includes(k)) {
        var i = this.filter_cs.indexOf(k)
        if(v == "-") {
          this.filter_cs.splice(i, 1)
          this.filter_vs.splice(i, 1)
        } else {
          this.filter_cs[i] = k
          this.filter_vs[i] = v
        }
      } else {
        this.filter_cs.push(k)
        this.filter_vs.push(v)
      }
    },
    showRecordModal: function(i, index) {
      this.recordModal = true
      this.record = i

      this.itemIndex = index
    },
    showDeleteModal: function(i, index) {
      this.deleteModal = true
      this.record = i
      this.itemIndex = index
    },
    hideDeleteModal: function() {
      this.deleteModal = false
    },
    updatePageData: function(n, e) {
      this.page = n
      console.log(e)
      axios
        .get(process.env.VUE_APP_API_ENDPOINT + "/users?page=" + n + "&word=" + this.word, {headers: {'Authorization': 'Bearer ' + this.idToken}})
        .then(response => {
          this.users = response.data.users
          this.meta = response.data.meta
        }).catch(error => {
          this.errorNotify(error.response)
        })
    },
  },
  mounted() {
    axios
      .get(process.env.VUE_APP_API_ENDPOINT + "/users?column=created_at&direction=desc", {headers: {'Authorization': 'Bearer ' + this.idToken}})
      .then(response => {
        console.log(response.data.users)
          this.users = response.data.users
          this.meta = response.data.meta

          this.isLoading = false
      }).catch(error => {
          this.errorNotify(error.response)
      })

    axios
      .get(process.env.VUE_APP_API_ENDPOINT + "/industries", {headers: {'Authorization': 'Bearer ' + this.idToken}})
      .then(response => {
          response.data.industries.forEach((i) => {
            this.industries[i.id] = i.name
            this.industryTypes.push({
                value: i.id,
                label: i.name
            })
            this.industries = Object.assign({}, this.industries)
          })
      }).catch(error => {
          this.errorNotify(error.response)
      })
  },
  computed: {
    ...mapGetters({
      partner:'GetPartner',
      idToken:'GetIdToken',
    })
  },
}
</script>
